import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ClassNames, Modal, Paging } from '@lsq-frontend/common-ui';
import { getRouterLinkUrlById, ResponsiveService } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';
import { FACTORING_TERMS } from '../../../../constants/copy.constants';
import { atlas, FACTORING } from '@lsq-frontend/fasttrack-shared/routing-atlas';

@Component({
    selector: 'lsq-upload-invoices-footer',
    template: `
        <ng-container *ngIf="showSubmit && !disableSubmit && (responsiveService.smBelow | async)">
            <span class="terms-message terms-message-sm-below">
                By clicking Submit, I acknowledge that I have read and agree to the
                <a (click)="showTermsModal()" href="javascript:void(0)">TERMS</a>
            </span>
        </ng-container>

        <div class="upload-invoices-footer">
            <div
                [ngClass]="[
                    'upload-invoices-footer-inner',
                    'container-fluid page-container d-flex justify-content-between align-items-center flex-row-reverse'
                ]"
            >
                <lsq-button
                    *ngIf="showContinue"
                    appearance="primary"
                    size="sm"
                    [disabled]="disableContinue"
                    (buttonClick)="navigate.emit(1)"
                >
                    Continue
                </lsq-button>

                <div *ngIf="showSubmit">
                    <ng-container *ngIf="!(responsiveService.smBelow | async)">
                        <span *ngIf="!disableSubmit" class="terms-message">
                            By clicking Submit, I acknowledge that I have read and agree to the
                            <a (click)="showTermsModal()" href="javascript:void(0)">Terms</a>
                        </span>
                    </ng-container>
                    <lsq-button
                        type="submit"
                        size="sm"
                        [disabled]="disableSubmit"
                        [submitting]="isSubmitting"
                        (buttonClick)="submit.emit()"
                    >
                        Submit
                    </lsq-button>
                </div>

                <lsq-button
                    *ngIf="showBackToDashboard"
                    type="submit"
                    size="md"
                    (buttonClick)="goToDashboard()"
                >
                    Back to Dashboard
                </lsq-button>

                <lsq-button
                    *ngIf="showBack"
                    appearance="transparent"
                    buttonClass="back-btn"
                    [disabled]="disableBack"
                    (buttonClick)="navigate.emit(-1)"
                >
                    Go back
                </lsq-button>
            </div>
        </div>
    `,
    styleUrls: ['./upload-invoices-footer.component.scss']
})
export class UploadInvoicesFooterComponent {
    @Input() public disableBack = true;
    @Input() public disableContinue = true;
    @Input() public disableSubmit = true;
    @Input() public showBack = true;
    @Input() public showContinue = true;
    @Input() public showSubmit = false;
    @Input() public isSubmitting = false;
    @Input() public showBackToDashboard = false;
    @Output() public submit = new EventEmitter<void>();
    @Output() public navigate = new EventEmitter<Paging>();

    public classNames = ClassNames;

    constructor(
        public responsiveService: ResponsiveService,
        private _router: Router,
        private _modalService: ModalService
    ) {}

    public async goToDashboard(): Promise<void> {
        await this._router.navigateByUrl(getRouterLinkUrlById(atlas, FACTORING));
    }

    public showTermsModal(): void {
        this._modalService.showModal(
            new Modal({
                id: 'terms-modal',
                title: 'Terms of Service',
                bodyText: FACTORING_TERMS,
                showFooter: true,
                showOkButton: true,
                okButtonText: 'Ok'
            })
        );
    }
}
